import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { ConsentList } from "./ConsentList";

export const ConsentPage: FC = () => {
	return (
		<Routes>
			<Route index element={<ConsentList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
